
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certifications/[certificationSlug]",
      function () {
        return require("private-next-pages/certifications/[certificationSlug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certifications/[certificationSlug]"])
      });
    }
  